import classNames from "classnames"
import React from "react"
import classes from "./OrderByPanel.module.css"
import CustomButton from "../../../../../ui/atoms/Button"
import { CustomBox } from "../../../../../ui/spacings"
import { useAlgoliaSearchState } from "../../controller/state"
import { SerpUi } from "../../../context/ui"
import { SearchSortBy } from "../../../../../features/algolia/api/types/search"

interface Props {
  updateUiState: (value: Partial<SerpUi>) => void
}

export const OrderByPanel = ({ updateUiState }: Props) => {
  const {
    orderByOptions,
    searchParams,
    updateSearchParams,
  } = useAlgoliaSearchState()

  const handleOrderByChange = (id: SearchSortBy) => {
    updateSearchParams((state) => ({
      ...state,
      orderBy: id,
    }))
    updateUiState({
      orderByExpanded: false,
    })
  }

  return (
    <CustomBox minHeight="100vh" px={1} py={3} textCenter>
      {orderByOptions.map((item) => (
        <CustomBox key={item.key} flex="row" justifyContent="center" my={1.5}>
          <CustomButton
            variant="text"
            className={classes.button}
            onClick={() => handleOrderByChange(item.key)}
            invariantCase
          >
            <div
              className={classNames(classes.label, {
                [classes.selected]: item.key === searchParams.orderBy,
              })}
            >
              {item.label}
            </div>
          </CustomButton>
        </CustomBox>
      ))}
    </CustomBox>
  )
}
